"use client";

import { c as _c } from "react/compiler-runtime";
import { Grid } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { useItemView } from "../../ItemViewProvider";
import { PAGE_SIZE } from "../constants";
import { CollectionItemsCard } from "./CollectionItemsCard";
const ITEMS = range(PAGE_SIZE).map(() => undefined);
export function CollectionItemsGridSkeleton() {
  const $ = _c(2);
  const {
    size
  } = useItemView();
  let t0;
  if ($[0] !== size) {
    t0 = <Grid className="pb-4" itemKey={_temp} items={ITEMS} renderItem={CollectionItemsCard} size={size} />;
    $[0] = size;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(_, index) {
  return String(index);
}